import Select, { components } from 'react-select';
import { TbGridDots } from 'react-icons/tb';
import { HiChevronDown } from 'react-icons/hi';
import { FaSpinner } from 'react-icons/fa'; // 🆕 spinner
import { getFacilityDropdown } from '../../../Redux/user/action';
import Form from 'react-bootstrap/Form';
import { useEffect, useState } from 'react';

const Facilitydropdown = ({ lockboxformik, isSingle = false, width = "250px", name = "facility",clients="clients",isDisabled=false,isDisableOnchange=false,fontSize = '17px' }) => {
	const [isFocusedFacility, setIsFocusedFacility] = useState(false);
	const [facilities, setFacilities] = useState([]);
	const [isLoadingFacilities, setIsLoadingFacilities] = useState(false); // 🆕

	const DropdownIndicator = ({ state, ...props }) => (
		<components.DropdownIndicator {...props}>
			{isLoadingFacilities ? (
				<FaSpinner className="react-select-spinner" style={{ fontSize: "1.5em", animation: "spin 1s linear infinite" }} />
			) : lockboxformik.values?.[state]?.length > 1 ? (
				<TbGridDots style={{ fontSize: "1.5em" }} />
			) : (
				<HiChevronDown style={{ fontSize: "1.5em" }} />
			)}
		</components.DropdownIndicator>
	);

	useEffect(() => {
		let apiTimeout = null;

		if (lockboxformik?.values?.[clients]?.length > 0) {
			setIsLoadingFacilities(true); // 🆕 start loading

			apiTimeout = setTimeout(() => {
				getFacilityDropdown(lockboxformik?.values?.[clients])((response) => {
					setIsLoadingFacilities(false); // 🆕 end loading

					if (response?.status) {
						const apiResponse = response?.data?.facilities || [];
						const selectedFacilitiesIds = apiResponse.flatMap(i => i?.facilities)?.map(ite => ite.value);
						const filterFacility = lockboxformik.values?.[name]?.filter(i => selectedFacilitiesIds.includes(i));

						lockboxformik.setFieldValue(name, filterFacility || []);
						setFacilities(
							apiResponse.map(result => (
								isSingle
									? { options: result?.facilities }
									: { options: result?.facilities, label: result?.client }
							))
						);
					}
				});
			}, 600);
		} else {
			setFacilities([]);
			lockboxformik.setFieldValue(name, []);
		}

		return () => clearTimeout(apiTimeout);
	}, [JSON.stringify(lockboxformik?.values?.[clients])]);

	const handleChange = (e) => {
		lockboxformik.setFieldValue(name, !isSingle ? e.map(i => i.value) : [e?.value]);
	};

	const value = facilities?.flatMap(i => i?.options)?.filter(j => lockboxformik?.values?.[name]?.includes(j?.value));

	return (
		<div style={{ width: `${width}` }}>
			<Form.Group>
				<Select
					className="basic-single select-search-facility"
					classNamePrefix="select"
                    isDisabled={isLoadingFacilities||isDisabled}
					isMulti={!isSingle}
					tabSelectsValue={false}
					closeMenuOnSelect={isSingle}
					value={value}
					name={name}
					components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state={name} /> }}
					options={facilities}
					onFocus={() => setIsFocusedFacility(true)}
					onBlur={() => setIsFocusedFacility(false)}
					onChange={isDisableOnchange ? undefined : handleChange}
					placeholder="Select Facility"
					menuPortalTarget={document.body}
					styles={{
						container: (styles) => ({ ...styles, borderRadius: "9px" }),
						placeholder: (styles) => ({ ...styles, fontSize: fontSize }),
						control: (styles, state) => ({
							...styles,
							backgroundColor: "hsl(204deg 33.33% 97.06%)",
							borderStyle: "none",
							boxShadow: "none",
							borderRadius: "10px",
							maxHeight: state.isFocused ? "auto" : "30px"
						}),
						indicatorSeparator: (styles) => ({ ...styles, width: "0px", minHeight: "20px" }),
						valueContainer: (styles, state) => ({
							...styles,
							maxHeight: isFocusedFacility ? "auto" : "30px"
						}),
						menuPortal: (styles) => ({
							...styles,
							zIndex: 9999
						})
					}}
				/>
				{lockboxformik.errors?.[name] && (
					<span className='text-danger'>{lockboxformik.errors?.[name]}</span>
				)}
			</Form.Group>
		</div>
	);
};

export default React.memo(Facilitydropdown);
